import { IntegerMath } from 'integer-math';

export class TaxUtil {
	public static calculate(
		subtotal: bigint,
		percentStr: string,
		isInclusive: boolean,
		precision: number
	): { subtotal: bigint; tax: bigint } {
		const math = new IntegerMath(precision);
		return math.adjustTax(subtotal, percentStr, isInclusive);
	}

	public static caculateFromScaledValue(
		subtotal: bigint,
		scaledTaxRate: bigint | number | string,
		isInclusive: boolean,
    precision: number,
	): { subtotal: bigint; tax: bigint } {
		const divisor = 10 ** precision;
		const numericRate = typeof scaledTaxRate === 'bigint' ? Number(scaledTaxRate) : Number(scaledTaxRate || 0);
		const percentStr = (numericRate / divisor).toString();
		return this.calculate(subtotal, percentStr, isInclusive, precision);
  }
}
